import { styled } from 'shared/Houston';

export const Error = styled.span`
  position: relative;
  padding: ${({ theme }) => `${theme.spacing.squish.xxs}`};
  border-radius: ${({ theme }) => theme.border.radius.pill};
  background-color: ${({ theme }) => theme.feedbackColor.negative.medium};
  color: ${({ theme }) => theme.neutralColor.low.pure};
  font-size: ${({ theme }) => theme.font.size.xxxs};
  z-index: 2;
`;
